import * as types from "./mutation_types";

export default {
  [types.LIGNE_ROB_STRUCT_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
      previous: null,
      next: null,
    });
  },

  [types.LIGNE_ROB_STRUCT_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.LIGNE_ROB_STRUCT_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.LIGNE_ROB_STRUCT_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
